<template>
  <v-card>
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <textOrChip :itemData="checkOnValidInfo(data.meetName)" />
          </v-list-item-title>
          <v-list-item-subtitle>
            <textOrChip :itemData="checkOnValidInfo(data.meetDesc)" />
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list>
      <v-list-item>
        <v-list-item-title>
          Address
        </v-list-item-title>
        <v-list-item-subtitle>
          <textOrChip :itemData="checkOnValidInfo(data.meetAddress)" />
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          Meet type:
        </v-list-item-title>
        <v-list-item-subtitle>
          <textOrChip :itemData="checkOnValidInfo(data.meetType)" />
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          Sport type:
        </v-list-item-title>
        <v-list-item-subtitle>
          <textOrChip :itemData="checkOnValidInfo(data.sport)" />
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          State:
        </v-list-item-title>
        <v-list-item-subtitle>
          <textOrChip :itemData="checkOnValidInfo(data.state)" />
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          Date from:
        </v-list-item-title>
        <v-list-item-subtitle>
          <textOrChip :itemData="checkOnValidInfo(data.meetDate)" />
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          Date to:
        </v-list-item-title>
        <v-list-item-subtitle>
          <textOrChip :itemData="checkOnValidInfo(data.meetDateTo)" />
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          Contact info:
        </v-list-item-title>
        <v-list-item-subtitle>
          <textOrChip :itemData="checkOnValidInfo(data.contactInfo)" />
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          Meet website:
        </v-list-item-title>
        <v-list-item-subtitle>
          <textOrChip :itemData="checkOnValidInfo(data.urlToDetails)" />
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import textOrChip from "@/components/base/textOrChip";
import { booleanChecker } from "@/_helpers/index";
export default {
  components: { textOrChip },
  props: {
    data: {
      type: [Array, Object],
      required: true
    }
  },
  methods: {
    checkOnValidInfo(item) {
      return booleanChecker(item);
    }
  }
};
</script>
